import ExitToAppIcon from "@mui/icons-material/OutputRounded";
import { Box, Button, Tooltip } from "@mui/material";
import type { ReactPortal } from "react";
import { useState } from "react";
import { createPortal } from "react-dom";
import { useExportStateContext } from "../../builder/common/contexts/ExportStateContext";
import ExportOptionsMenu from "./ExportOptionsMenu.tsx";
import type { ExportOption } from "./exportOptions.tsx";

interface Props {
  options: ExportOption[];
  warning?: string;
  exporting?: boolean;
  showPrecisionOptions?: boolean;
}

const ExportButton = ({ options, warning, exporting, showPrecisionOptions }: Props): ReactPortal | null => {
  const { container, disabled, valueSettings: settings } = useExportStateContext();

  const [openExportMenu, setOpenExportMenu] = useState(false);
  const [btnRef, setBtnRef] = useState<HTMLElement | null>(null);

  const valueSettings = showPrecisionOptions ? settings : undefined;

  if (!container) {
    return null;
  }

  return createPortal(
    <>
      <Tooltip title={warning || ""} arrow>
        <Box>
          <Button
            ref={setBtnRef}
            variant="outlined"
            color="secondary"
            startIcon={<ExitToAppIcon />}
            loading={exporting}
            onClick={() => setOpenExportMenu(true)}
            disabled={!!warning || exporting || disabled}
            sx={{ "& .MuiButton-label": { whiteSpace: "nowrap" } }}
          >
            Export
          </Button>
        </Box>
      </Tooltip>

      <ExportOptionsMenu
        anchorEl={btnRef}
        open={openExportMenu}
        onClose={() => setOpenExportMenu(false)}
        options={options}
        valueSettings={valueSettings}
        disabled={disabled}
      />
    </>,
    container
  );
};

export default ExportButton;
